import { ExportIcon } from "@xola/icons";
import { Breadcrumb, FadeIn, HeaderToolbar, Skeleton } from "@xola/ui-kit";
import { DateFormat, formatDate } from "common";
import React from "react";
import { useQuery } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import { PayoutTransaction } from "types";
import { api } from "../../api/api";
import { NoTranslate } from "../../components/Common/NoTranslate";
import { SecondaryButton } from "../../components/Common/SecondaryButton";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { PayoutDetailsTable } from "../../components/Reports/Payouts/PayoutDetailsTable";
import { ExportPayoutEventsModal } from "../../components/Reports/Payouts/PayoutFilter";
import { useModal } from "../../hooks/useVisibility";
import { numberFormat } from "../../utils/numbers";
import { Page } from "../Page";

export const PayoutDetailsPage = () => {
    const history = useHistory();
    const params = useParams<{ id: ID }>();
    const handleClick = () => history.push("/reports/payouts");

    // TODO: Why does it not use useCollection?
    const { data } = useQuery<PayoutTransaction>(`transaction${params.id}`, async () => {
        const { data } = await api.get<PayoutTransaction>(`transactions/${params.id}`);
        return data;
    });

    const getHeaderTitle = (payout?: PayoutTransaction) => {
        if (!payout) {
            return null;
        }

        const payoutStart = formatDate(payout.payoutStart, DateFormat.DATE_SHORT);
        const payoutEnd = formatDate(payout.payoutEnd.subtract(1, "second"), DateFormat.DATE_SHORT);
        return `${payoutStart} - ${payoutEnd} (${numberFormat(-1 * payout.amount, payout.currency)})`;
    };

    return (
        <Page title="Payout">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Payouts</Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {data ? (
                                <FadeIn as="span">
                                    <NoTranslate>{getHeaderTitle(data)}</NoTranslate>
                                </FadeIn>
                            ) : (
                                "Loading"
                            )}
                        </Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                {data ? (
                    <ExportPayoutTransactionsButton payout={data} />
                ) : (
                    <div className="flex h-[65px] justify-end px-6 py-3">
                        <Skeleton height={40} classNames={{ container: "justify-end w-48 !bg-gray-lighter" }}>
                            <ExportIcon className="mr-1" />
                            Export Transactions
                        </Skeleton>
                    </div>
                )}

                <ColumnLayout.Fill>
                    <div className="px-6 py-3">
                        <PayoutDetailsTable />
                    </div>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};

const ExportPayoutTransactionsButton = ({ payout }: { payout: PayoutTransaction }) => {
    const exportModal = useModal();

    return (
        <div className="flex flex-row items-center justify-end border-b border-gray-light px-6 py-3">
            <div className="shrink-0 space-x-2 place-self-end pl-2">
                <SecondaryButton icon={<ExportIcon />} onClick={exportModal.show}>
                    Export Transactions
                </SecondaryButton>
            </div>

            <ExportPayoutEventsModal payout={payout} isOpen={exportModal.isVisible} onClose={exportModal.hide} />
        </div>
    );
};
